import { Stack, XStack } from '@my/ui'
import { ArticleCardAlt } from '../article-card'

export interface ArticleGridProps {
  imagePriority?: boolean
  articles: {
    id: string
    title: string
    shortDescription: string
    featuredImage: {
      url: string
      alt: string
    }
    primaryCategory: {
      name: string
      slug: string
    }
    slug: string
  }[]
}

export const ArticleGrid = ({ articles, imagePriority }: ArticleGridProps) => {
  return (
    <XStack flexWrap="wrap" m={-8}>
      {articles.map((item) => (
        <Stack w="100%" $gtXs={{ w: '50%' }} p={8} key={item.id}>
          <ArticleCardAlt {...item} imagePriority={imagePriority} />
        </Stack>
      ))}
    </XStack>
  )
}
